import React, { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import sha256 from 'crypto-js/sha256';
import PointageDisplay from './PointageDisplay';
import PointageSelection from './PointageSelection';

function PointageUser() {
    const { t } = useTranslation();

    const apiUrl = process.env.REACT_APP_BACKEND_URL
    const ImageUrl = process.env.REACT_APP_IMAGES_URL
    const frontEndUrl = process.env.REACT_APP_REACT_URL


    let userId = Cookies.get('userId');
    let UserToken = Cookies.get('UserSpecialToken');
    let IdEntreprise = Cookies.get('IdEntreprise');


    let LanguageSelected = Cookies.get('LanguageSelected');
    const [poitageParams, setPointageParams] = useState(false)

    // Pointage is only available for users linked to an entreprise
    if (!IdEntreprise || IdEntreprise === 'null' || IdEntreprise === 'undefined') {
        return null
    }

    return (
        <div>
            <button onClick={() => setPointageParams(true)} type="submit" className="w-full btn-edit">
                {t('Pointage')}
            </button>

            {poitageParams &&
                <div className="fixed z-50 left-0 top-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10">
                    <div className="relative w-full max-h-screen findservice overflow-hidden -mt-10 rounded-xl  div-sections">
                        <div className={`${LanguageSelected == 'ar' ? 'absolute -top-2 -left-2 p-4 ' : 'absolute -top-2 -right-2 p-4'}`} >
                            <a className='w-7 h-7' onClick={() => { setPointageParams(false) }}>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                                </svg>
                            </a>
                        </div>
                        <div className="w-full  ">
                            <div className={`${LanguageSelected == 'ar' ? 'pl-6 ' : 'pr-6'}`} >
                                <div className="flex  items-center justify-start ">
                                    <p className="text-2xl text-gold px-3 py-2 font-bold">{t("Pointage Settings")}</p>
                                </div>
                            </div>
                            <div className='grid place-items-center w-full pb-5 gap-1 px-4'>
                                <PointageDisplay />
                                <PointageSelection />

                            </div>
                        </div>
                    </div>
                </div>

            }
        </div>
    )
}

export default PointageUser